import { EventBus } from '@/eventBus.js';
import SearchResultItem from '@/ecm/models/search/results/SearchResultItem';
export default {
    props: {
        documentDto: {
            type: Object,
        },
        isSelected: {
            type: Boolean,
        },
        fieldsCount: {
            type: Number,
            default: 4,
        },
        selectedDocuments: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            showAttachments: false,
            showVersions: false,
            showComments: false,
            showHistory: false,
            showAlerts: false,
            showDistributions: false,
            showSignatures: false,
            fieldExpanded: false,
            showLinkedDocuments: false,
        };
    },
    computed: {
        getFields() {
            if (this.fieldExpanded) {
                return this.document.fields;
            }
            return this.document.fields.filter(f => f.isVisible).slice(0, this.fieldsCount);
        },
        document() {
            return new SearchResultItem(this.documentDto);
        },
    },
    mounted() {
        if (this.documentDto.expand) {
            this.fieldExpanded = this.documentDto.expand;
        }

    },
    methods: {
        getBackgroundColor(hover) {
            if (this.isSelected) {
                if (this.document.isBlocked && this.document.documentDeferredProcessType == 2) {
                    return 'deep-orange lighten-5';
                } else if (this.document.isBlocked) {
                    return 'amber lighten-5';
                }
                return 'blue lighten-5';
            }

            if (hover && !this.document.isBlocked) {
                return 'grey lighten-4';
            }

            if (this.document.isBlocked) {
                if (this.document.documentDeferredProcessType === 2) {
                    return 'deep-orange lighten-4';
                }
                return 'amber lighten-4';
            }

            return 'grey lighten-5';
        },
        onFieldsClick() {
            this.$emit('on-content-click', this.document.id);
        },
        onEditClick() {
            this.$emit('on-edit-click', this.document.id);
        },
        onFlowDiagramClick() {
            this.$emit('on-flow-diagram-click', this.document.id);
        },
        onSignClick() {
            this.$emit('on-sign-click', this.document.id);
        },
        onActionClick(action) {
            var fieldExpanded = false;
            var showComments = false;
            var showVersions = false;
            var showAttachments = false;
            var showHistory = false;
            var showAlerts = false;
            var showDistributions = false;
            var showSignatures = false;
            var showLinkedDocuments = false;

            switch (action) {
            case 'comment':
                showComments = !this.showComments;
                break;
            case 'expand':
                fieldExpanded = !this.fieldExpanded;
                this.onExpandChange(fieldExpanded);
                break;
            case 'version':
                showVersions = !this.showVersions;
                break;
            case 'history':
                showHistory = !this.showHistory;
                break;
            case 'alert':
                showAlerts = !this.showAlerts;
                break;
            case 'attachment':
                showAttachments = !this.showAttachments;
                break;
            case 'distribution':
                showDistributions = !this.showDistributions;
                break;
            case 'signatures':
                showSignatures = !this.showSignatures;
                break;
            case 'linkedDocuments':
                showLinkedDocuments = !this.showLinkedDocuments;
                break;
            }
            this.fieldExpanded = fieldExpanded;
            this.showComments = showComments;
            this.showVersions = showVersions;
            this.showAttachments = showAttachments;
            this.showHistory = showHistory;
            this.showAlerts = showAlerts;
            this.showDistributions = showDistributions;
            this.showSignatures = showSignatures;
            this.showLinkedDocuments = showLinkedDocuments;
        },
        onLinkedDocumentsUpdated(count) {
            EventBus.$emit('linked-documents-updated', {
                objectID: this.documentDto.ObjectID,
                count: count,
            });
        },
        onCommentsUpdated(count) {
            EventBus.$emit('comments-updated', {
                objectID: this.documentDto.ObjectID,
                count: count,
            });
        },
        onAttachmentsUpdated(count) {
            EventBus.$emit('attachments-updated', {
                objectID: this.documentDto.ObjectID,
                count: count,
            });
        },
        onAlertUpdated(count) {
            EventBus.$emit('alerts-updated', {
                objectID: this.documentDto.ObjectID,
                count: count,
            });
        },
        onVersionClick(newObjectID) {
            const oldObjectID = this.document.id;
            this.$emit('on-version-change', { oldObjectID, newObjectID });
        },
        onSelectionChange(isSelected) {
            const documentId = this.document.id;
            this.$emit('on-selection-change', { isSelected, documentId });
        },
        onExpandChange(isExpand) {
            const documentId = this.document.id;
            this.$emit('on-expand-change', { isExpand, documentId });
        },
        onDocumentRemoved() {
            this.$emit('on-document-removed', this.document.id);
        },
        onDistributionEnded() {
            this.showDistributions = false;
            this.$emit('on-distribution-ended', this.document.id);
        },
        onVersionRemoved(newObjectID) {
            const oldObjectID = this.document.id;
            this.$emit('on-version-removed', { oldObjectID, newObjectID });
        },
        onDocumentBlocked() {
            this.$emit('on-document-blocked', this.document.id);
        },
        onReceptionConfirmed() {
            this.$emit('on-reception-confirmed', this.document.id);
        },
        onloadPluginClick(plugin) {
            const objectIDs = [this.document.id];
            this.$emit('on-load-plugin-click', { plugin, objectIDs });
        },
        dragover(event) {
            event.preventDefault();
            if (!event.currentTarget.classList.contains('yellow')) {
                event.currentTarget.classList.remove('grey');
                event.currentTarget.classList.remove('lighten-5');
                event.currentTarget.classList.add('yellow');
                event.currentTarget.classList.add('lighten-3');
            }
        },
        dragleave(event) {
            event.currentTarget.classList.add('grey');
            event.currentTarget.classList.add('lighten-5');
            event.currentTarget.classList.remove('yellow');
            event.currentTarget.classList.remove('lighten-3');
        },
        drop(event) {
            event.preventDefault();
            var files = event.dataTransfer.files;
            if (files.length > 0) {
                EventBus.$emit('dragAndDrop', {
                    documentId: this.document.id,
                    files: files,
                });
            }
            event.currentTarget.classList.add('grey');
            event.currentTarget.classList.add('lighten-5');
            event.currentTarget.classList.remove('yellow');
            event.currentTarget.classList.remove('lighten-3');
        },
        onRetryProcess() {
            this.$emit('on-retry-process', this.document.id);
        },
    },
};